import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

interface BreadcrumbProps {
  items: {
    label: string;
    link?: string; // optional, if not provided, it will be a plain text (active)
  }[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box">
          <ol className="breadcrumb m-0 mt-1">
            {items.map((item, index) => {

              const isSingle = items.length === 1;
              const isLastItem = !isSingle && index === items.length - 1;
              const isActive = !isSingle && (isLastItem || !item.link);

              return(
                <BreadcrumbItem key={index} active={isActive}>
                  {isSingle ? <h4 className="mb-sm-0 font-size-18">{item.label}</h4>
                  :
                  item.link && index !== items.length - 1 ? 
                  (index === 0 ? 
                    <h4 className="mb-sm-0 font-size-18">
                      <Link to={item.link} className="text-dark">{item.label}</Link>
                    </h4>
                    : 
                    <Link to={item.link} className="text-dark">{item.label}</Link>
                  ) 
                  :
                  (item.label)}
                </BreadcrumbItem>
              )}
            )}
          </ol>
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
